import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import walletheadboxCover from "../../../../../media/images/walletheadboxCover.svg";
import silverShare from "../../../../../media/images/silverShare.svg";
import CarTagView from "../../../../components/CarTag";

export default function BannerBox() {
  return (
    <Box
      sx={{
        backgroundImage: `
              linear-gradient(180deg, rgba(23,131,240,0.804359243697479) 0%, rgba(23,131,240,1) 100%),
            url(${walletheadboxCover})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        borderRadius: "20px",
        height: "130px",
        justifyContent: "end",
        paddingX: "8px",
        paddingY: "8px",
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.20)",
      }}
    >
      <Grid
        sx={{
          height: "100%",
          justifyContent: "space-between",
        }}
        container
      >
        <Grid item xs={8}>
          <Box
            sx={{
              //   border: "1px solid gray",
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                // border: "1px solid gray",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                }}
              >
                رضا یعقوبی‌فریان پور
              </Typography>
              <CarTagView />
            </Box>
            <Box
              sx={
                {
                  // border: "1px solid gray",
                }
              }
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "#fff",
                }}
              >
                موجودی:
              </Typography>
              <Typography
                sx={{
                  fontSize: "22px",
                  color: "#fff",
                }}
              >
                260,000,000
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3.5}>
          <Box
            sx={{
              borderRadius: "20px",
              //   border: "1px solid gray",
              height: "100%",
              width: "100%",
              backgroundColor: "#ECEFF1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img width={70} src={silverShare} alt="" />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              اشتراک نقره‌ای
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
